import OtpInput from 'react-otp-input'
import Text from '../../../components/atoms/Text'
import Phone from '../../../assets/icons/call_icon.svg'
import Edit from '../../../assets/icons/edit_green.svg'
import { useSelector } from 'react-redux'

const OtpInputView = ({
  contactNumber,
  otpCode,
  setOtpCode,
  onPressEditContactNumber,
  verifyOtpErrorMessage,
  resendTimer,
  handleSendOtp,
}) => {
  const { verifyOtp, userDetails } = useSelector((s) => s.auth)

  const otpInputStyle = {
    borderRadius: '8px',
    padding: '8px',
    height: '48px',
    width: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
    fontFamily: 'Roboto',
    fontWeight: '600',
    fontSize: '20px',
    lineHeight: '26px',
    textAlign: 'center',
    letterSpacing: '0.25px',
    color: 'text-primary',
  }

  const renderOtpInput = (
    <OtpInput
      value={otpCode}
      onChange={setOtpCode}
      numInputs={6}
      placeholder="------"
      inputType="number"
      renderSeparator={() => <div className="w-2" />}
      containerStyle={{
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      shouldAutoFocus
      inputStyle={otpInputStyle}
      renderInput={(props) => (
        <input
          {...props}
          // type="password"
          className={`border-solid border-[1px] ${
            verifyOtpErrorMessage && otpCode.length === 6
              ? `border-ERROR-600 shadow-sm ring-4 ring-ERROR-50`
              : `border-border-accent-indigo-primary shadow-sm focus:ring-4 ring-INDIGO-50`
          }`}
        />
      )}
    />
  )

  return (
    <>
      <div className="flex flex-col gap-2.5 p-4 relative z-10">
        <Text
          tag="p"
          variant="title"
          size="small"
          className="text-text-primary"
        >
          Enter Your OTP
        </Text>
        <div className="flex flex-col gap-1">
          <Text
            tag="p"
            variant="body"
            size="large"
            className="text-text-secondary !font-normal"
          >
            An OTP is sent to the following number
          </Text>
          <div className="flex flex-row items-center">
            <img src={Phone} alt="ph" className="h-4 w-4" />
            <div className="ml-1 mr-3">
              <Text
                tag="p"
                variant="body"
                size="large"
                className="text-text-secondary"
              >
                {contactNumber}
              </Text>
            </div>
            <button
              className="flex flex-row items-center gap-[2px]"
              onClick={onPressEditContactNumber}
            >
              <Text
                tag="p"
                variant="label"
                size="medium"
                bold="true"
                className="underline text-text-success-primary"
              >
                Edit
              </Text>
              <img src={Edit} alt="edit" className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-1.5 px-4 pb-4 relative z-10">
        <Text
          tag="p"
          variant="label"
          size="medium"
          className="text-text-primary"
        >
          Secure Code
        </Text>
        {renderOtpInput}
        {verifyOtpErrorMessage && otpCode.length === 6 && (
          <Text
            tag="span"
            variant="label"
            size="medium"
            className="text-ERROR-600"
          >
            {verifyOtpErrorMessage}
          </Text>
        )}
      </div>
      {verifyOtp.loading || userDetails.loading ? (
        <div className="px-4 pt-1 pb-4 flex items-center justify-center ">
          <svg
            aria-hidden="true"
            class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-text-brand-tertiary"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      ) : (
        <div className="flex flex-row items-center gap-2 px-4 pt-1 pb-4">
          <Text
            tag="p"
            variant="body"
            size="medium"
            className="text-text-quartenary"
          >
            Didn&apos;t receive the OTP?
          </Text>
          {resendTimer > 0 ? (
            <Text
              tag="p"
              variant="body"
              size="medium"
              className="text-text-quartenary"
            >
              Resend OTP in 00:{resendTimer.toString().padStart(2, '0')}
            </Text>
          ) : (
            <button onClick={handleSendOtp}>
              <Text
                tag="p"
                variant="label"
                size="medium"
                className="underline text-text-success-primary"
                bold="true"
              >
                Resend
              </Text>
            </button>
          )}
        </div>
      )}
    </>
  )
}

export default OtpInputView
